<div class="atn-space-lab-assignments">
  <atn-ds-table [config]="tableConfig()" />
</div>

@if (
  recordLabAssignmentsEc.plugins.currentEntityPlugin.feature.selectors
    .isCreating()
    .asSignal()
) {
  <atn-space-assign-labs-to-lab-service-modal />
}

@if (
  recordLabAssignmentsEc.plugins.editingPlugin.feature.selectors.hasDeletions.asSignal()
) {
  <atn-ds-confirmation-overlay
    title="Delete Lab Assignment"
    description="Deleting this laboratory assignment can't be undone. Are you sure you want to remove it from this lab service?"
    (cancel)="cancelDeletionClickHandler()"
    (confirm)="confirmDeletionClickHandler()"
    confirmButtonText="Delete"
  />
}
